export const FREE_CHAPTER_COUNT = 7;
export const CHAPTER_UNLOCK_THRESHOLD_PERCENT = 75;

export const LOCK_REASONS = {
  paid: "Purchase the course to unlock.",
  progress: "Complete at least 75% of the previous chapter to unlock.",
};

export const getChapterUnlockStatus = ({
  chapterIndex,
  isPaidUser,
  isAdmin,
  chapterCompletionPercents = [],
}) => {
  if (isAdmin || isPaidUser) {
    return { unlocked: true, reason: null };
  }

  // First chapter always unlocked
  if (chapterIndex === 0) {
    return { unlocked: true, reason: null };
  }

  // Only first N chapters are eligible for free unlock
  if (chapterIndex >= FREE_CHAPTER_COUNT) {
    return { unlocked: false, reason: LOCK_REASONS.paid };
  }

  const prevPercent = Number(chapterCompletionPercents[chapterIndex - 1] ?? 0);
  if (prevPercent >= CHAPTER_UNLOCK_THRESHOLD_PERCENT) {
    return { unlocked: true, reason: null };
  }

  return { unlocked: false, reason: LOCK_REASONS.progress };
};
